import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Carousel from 'tbk-components/src/components/Carousel';
import CarouselItem from 'tbk-components/src/components/CarouselItem';
import Blockquote from 'tbk-components/src/components/Blockquote';

export interface ITestimonial {
	/**
	 * @control textarea
	 */
	text?: string;
	author?: string;
}

export interface ITestimonialsCarouselProps extends IBaseElementProps {
	testimonials?: ITestimonial[];
}

/**
 * Testimonials Carousel
 * @block
 * @requiresHooks
 * @icon align-center
 */
const TestimonialsCarousel: React.FC<ITestimonialsCarouselProps> = ({
	testimonials,
	className,
	classNames = [],
}) => (
	<div className={className || cn('testimonials-carousel', ...classNames)}>
		<Carousel>
			{(testimonials || []).map(({ text, author }, index) => (
				<CarouselItem key={index}>
					<Blockquote source={author}>{text}</Blockquote>
				</CarouselItem>
			))}
		</Carousel>
	</div>
);

export default TestimonialsCarousel;
